<template>
  <b-modal size="lg" v-model="visible" title="Dodaj wyraz do tematu" @ok="onOk" @show="onShow">
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Wyraz">
        <multiselect
          v-model="item"
          track-by="id"
          label="term"
          placeholder="Wybierz wyraz"
          :options="items"
          :loading="searching"
          @search-change="onSearch"
          @open="onSearch"
          :internal-search="false"
          :searchable="true"
          :allow-empty="false"
        >
          <template slot="singleLabel" slot-scope="{option}">
            <span>
              #{{option.id}}: {{option.term}}
              <span
                class="text-lowercase"
                style="display:block"
              >({{option.translation}})</span>
            </span>
          </template>
        </multiselect>
      </b-form-group>

      <b-form-group class="required" label="Dzień">
        <multiselect
          v-model="day"
          track-by="value"
          label="text"
          placeholder="Wybierz dzień"
          :options="days"
          :internal-search="false"
          :searchable="false"
          :allow-empty="false"
        >
          <template slot="singleLabel" slot-scope="{option}">
            <span>{{option.text}}</span>
          </template>
        </multiselect>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";
import multiselect from "vue-multiselect";

export default {
  components: {
    multiselect
  },
  data() {
    return {
      day: null,
      days: [
        { value: 1, text: "Dzień 1" },
        { value: 2, text: "Dzień 2" },
        { value: 3, text: "Dzień 3" },
        { value: 4, text: "Dzień 4" },
        { value: 5, text: "Dzień 5" }
      ],
      item: null,
      items: [],
      searching: false,
      visible: false
    };
  },
  validations: {
    item: { required },
    day: { required }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();
      this.item = null;
      this.day = null;
    },

    onSearch(searchClause) {
      this.searching = true;

      axios
        .get("/words", {
          params: {
            sortBy: "termlength",
            startsWithTerm: searchClause,
            sortDesc: false,
            perPage: 20,
            currentPage: 1
          }
        })
        .then(response => {
          var result = response.data;
          this.items = result.rows;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.searching = false;
        });
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.$v.$touch();

      var result = {
        wordId: this.item.id,
        day: this.day.value
      };
      if (!this.$v.$error) {
        this.$emit("save", result);
        this.visible = false;
      }
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
</style>

